import { SHIFTS_PER_DAY } from "@/lib/Constants";
import { classNames } from "@/lib/Util";
import { translate } from "@/components/IntlProviderWrapper";

import "./DayShiftsToggle.scss";

type DayShiftsToggleProps = {
    selectedShifts: boolean[];
    onSelectedShiftsChange: (selectedShifts: boolean[]) => void;
};

/**
 * Coerces the `selectedShifts` array to length `SHIFTS_PER_DAY` (strict booleans).
 */
const normalizeSelectedShifts = (selectedShifts: boolean[]): boolean[] =>
    Array.from({ length: SHIFTS_PER_DAY }, (_, index) => selectedShifts[index] === true);

/**
 * Renders a toggle for each shift in a day.
 */
const DayShiftsToggle = ({ selectedShifts, onSelectedShiftsChange }: DayShiftsToggleProps) => {
    const shifts = normalizeSelectedShifts(selectedShifts);

    const handleShiftToggle = (shiftIndex: number) => {
        onSelectedShiftsChange(shifts.map((isSelected, index) => (index === shiftIndex ? !isSelected : isSelected)));
    };

    return (
        <div className="day-shifts-toggle">
            {shifts.map((isSelected, shiftIndex) => {
                const shiftNumber = shiftIndex + 1;
                return (
                    <button
                        key={shiftIndex}
                        type="button"
                        onClick={() => handleShiftToggle(shiftIndex)}
                        aria-pressed={isSelected}
                        aria-label={`${translate("common.shift", "Shift")} ${shiftNumber}`}
                        className={classNames(
                            "day-shifts-toggle__button",
                            `day-shifts-toggle__button--shift-${shiftNumber}`,
                            { "is-selected": isSelected }
                        )}
                    >
                        {shiftNumber}
                    </button>
                );
            })}
        </div>
    );
};

export default DayShiftsToggle;
export type { DayShiftsToggleProps };
